module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-stone-path-background.54018ccf.png";